import { fetchAPI } from '@quickbit/backoffice-core-frontend';
import { MerchantConfig, MerchantConfigUpdateInput } from '../api';
import { Platform } from './types';

// Convert decimal tolerance values from backend to percentage for display
const convertConfigFromBackend = (data: MerchantConfig): MerchantConfig => ({
  ...data,
  config: {
    ...data.config,
    amountToleranceLowerBound: data.config.amountToleranceLowerBound * 100,
    amountToleranceUpperBound: data.config.amountToleranceUpperBound * 100,
  },
});

// Convert percentage tolerance values from frontend to decimal for backend
const convertConfigToBackend = (
  input: MerchantConfigUpdateInput
): Record<string, unknown> => {
  if (!input.config) {
    return { ...input };
  }
  return {
    ...input,
    config: {
      ...input.config,
      amountToleranceLowerBound: input.config.amountToleranceLowerBound / 100,
      amountToleranceUpperBound: input.config.amountToleranceUpperBound / 100,
    },
  };
};

export const getConfigAsPlatform = async (merchantId: string) => {
  const data = await fetchAPI<MerchantConfig>(`v1/config/${merchantId}`, {
    method: 'GET',
  });
  return convertConfigFromBackend(data);
};

export const updateConfigAsPlatform = async (
  merchantId: string,
  config: MerchantConfigUpdateInput
) => {
  const data = await fetchAPI<MerchantConfig>(`v1/config/${merchantId}`, {
    method: 'PUT',
    body: convertConfigToBackend(config),
  });

  return convertConfigFromBackend(data);
};

export const getPlatformConfig = async () => {
  const data = await fetchAPI<Platform>(`v1/config/platform`, {
    method: 'GET',
  });

  return data;
};

export const updatePlatformConfig = async (platformForm: Platform) => {
  const data = await fetchAPI<Platform>(`v1/config/platform`, {
    method: 'PUT',
    body: {
      ...platformForm,
    },
  });

  return data;
};
